import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import { Button } from "@/components/ui/button";

import { useParams } from "@tanstack/react-router";
import { ArrowLeftIcon } from "lucide-react";

export function LotMovementsPage() {
  const { id } = useParams({ from: "/app/inventory/lots/$id/movements" });

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            {
              label: "ລາຍການ Lot",
              to: "/app/inventory/lots",
            },
            {
              label: "ປະຫວັດ Movement",
            },
          ]}
        />
      </Header>
      <Main>
        <div className="mb-4 flex items-center gap-2">
          <Button
            variant="outline"
            size="icon"
            onClick={() => window.history.back()}
          >
            <ArrowLeftIcon className="size-4" />
          </Button>
          <h2 className="font-bold text-2xl">ປະຫວັດ Movement — Lot</h2>
        </div>
        <p className="text-muted-foreground">
          Lot ID: {id} — ຫນ້ານີ້ຈະສະແດງປະຫວັດການເຄື່ອນໄຫວຂອງ lot ໃນໄລຍະພັດທະນາຕໍ່ໄປ.
        </p>
      </Main>
    </>
  );
}
